import { inject, Pipe, PipeTransform } from '@angular/core';
import { AuthStore } from 'app/core/stores';
import { filter, map } from 'rxjs';
import { User } from '@auth0/auth0-angular';

@Pipe({
    name: 'isMe',
    standalone: true,
    pure: true,
})
export class IsMePipe implements PipeTransform {
    private readonly _authStore = inject(AuthStore);

    isMyMessage = false;

    transform(sender?: string | null, ...args: unknown[]) {
        return this._authStore.user$.pipe(
            filter((u): u is User => u != null),
            map(({ sub }) => (this.isMyMessage = sub === sender))
        );
    }
}
